import { RequestAction, createRequestTypes } from "store/entities/actions";
import { ISetInvoicesDataPayload } from "store/entities/invoices/interfaces";
import { ActionsUnion, createAction } from "store/helper";

export const InvoicesSelectorsNames = {
  DOWNLOAD_INVOICE: "VIEWS/INVOICES/DOWNLOAD_INVOICE",
};

export enum InvoicesViewActionsNames {
  INVOICE = "INVOICE",
  DOWNLOAD_INVOICE = "VIEWS/INVOICES/DOWNLOAD_INVOICE",
  FETCH_INVOICES_VIEW_DATA = "VIEWS/INVOICES/FETCH_INVOICES_VIEW_DATA",
  SET_INVOICES_VIEW_DATA = "VIEWS/INVOICES/SET_INVOICES_VIEW_DATA",
}

export const INVOICE = {
  DOWNLOAD: createRequestTypes(InvoicesSelectorsNames.DOWNLOAD_INVOICE),
};

const downloadInvoiceActions = {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  downloadInvoice: (id: number) => createAction(INVOICE.DOWNLOAD[RequestAction.REQUEST], { id }),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  downloadInvoiceSuccess: () => createAction(INVOICE.DOWNLOAD[RequestAction.SUCCESS]),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  downloadInvoiceFailure: () => createAction(INVOICE.DOWNLOAD[RequestAction.FAILURE]),
};

export const InvoicesViewActions = {
  ...downloadInvoiceActions,
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchInvoices: () => createAction(InvoicesViewActionsNames.FETCH_INVOICES_VIEW_DATA),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  setInvoicesData: (invoicesData: ISetInvoicesDataPayload) =>
    createAction(InvoicesViewActionsNames.SET_INVOICES_VIEW_DATA, invoicesData),
};

export type InvoicesViewAction = ActionsUnion<typeof InvoicesViewActions>;
